import { EnumPricingItemType } from "../in/quote/pricing-item/pricing-item-type";
import { OptionSummary } from "./option-summary";

export class PricingItemSummary {

    public codeElis: string;
    public label: string;
    public quantity: string;
    public appliedPrice: string;
    public totalAppliedPrice: string;
    public frequency: string;
    public exchangeRule: string;
    public unitStockInitialVT: string;
    public totalStockInitialVT: string;
    public initialStockLS: string;
    public initialstockBillLS: string;
    public initialStockSOL: string;
    public stockTotalHtPrice: string;
    public family: string;
    public numberOfChange: any;
    public consoCodeElis: string;
    public consoLabel: string;
    public consoQuantity: string;
    public consoAppliedPrice: string;
    public extraPrice: string;
    public collecteurExtraPrice: string;
    public serviceExtraPrice: string;
    public franchiseConso: string;
    public pricingItemType?: EnumPricingItemType;
    public displayOrder?: string;
    public option?: OptionSummary;

}
